module.exports = {
    "collectionLabel": `\u{5EFA}\u{8B70}`
};


//# sourceMappingURL=zh-TW.main.js.map
